/* Rail tab switching for the rail-style mega menu. Event delegation +
   init guard so the script stays correct when included more than once. */
(function () {
  if (window.__megaRailInit) return;
  window.__megaRailInit = true;

  function activate(btn) {
    var layout = btn.closest('.mega-rail-layout');
    if (!layout) return;
    layout.querySelectorAll('.mega-rail-btn.is-active').forEach(function (b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');
    layout.querySelectorAll('.mega-content-panel.is-active').forEach(function (p) {
      p.classList.remove('is-active');
    });
    var target = document.getElementById(btn.getAttribute('data-target'));
    if (target) target.classList.add('is-active');
  }

  ['mouseover', 'focusin'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var btn = e.target.closest && e.target.closest('.mega-rail-btn[data-target]');
      if (btn) activate(btn);
    });
  });
})();
